import HorizontalSlide from './horizontal-slide';
export default HorizontalSlide;